import OrganizationContainer from './containers/OrganizationContainer';

export default OrganizationContainer;
